// extracted by mini-css-extract-plugin
module.exports = {"component":"low-price-calendar_component__HMqfY"};